import ExpoConstants from 'expo-constants';
import type { ImageLoadEventData, ImageSource, ImageContentFit, ImageProps } from 'expo-image';
import { Image } from 'expo-image';
import type { ImageStyle, StyleProp } from 'react-native';

export interface ThermenImageProps {
	source: ImageSource | string | number | null;
	style?: StyleProp<ImageStyle>;
	onLoad?: (event: ImageLoadEventData) => void;
	contentFit?: ImageContentFit;
	priority?: ImageProps['priority'];
	alt?: string | undefined;
}

// Decorative by default; expo-image only writes the web alt from accessibilityLabel, never from its own alt.
function ThermenImage({ source, style, onLoad, contentFit, priority, alt = '' }: ThermenImageProps) {
	const appVersion = ExpoConstants?.expoConfig?.version ?? '';

	let imageSource: ImageSource | number | string = {};

	if (typeof source === 'string' || typeof source === 'number') {
		imageSource = source;
	} else if (source instanceof Object && 'uri' in source) {
		imageSource = { uri: source.uri, cacheKey: source.uri + appVersion };
	}

	return (
		<Image
			{...(contentFit ? { contentFit } : {})}
			{...(onLoad ? { onLoad } : {})}
			{...(priority ? { priority } : {})}
			accessibilityLabel={alt}
			source={imageSource}
			style={style}
		/>
	);
}

export default ThermenImage;
